var jq3 = jQuery.noConflict(true);